import axios from 'axios';
import app from '@/main';

export default axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.request.response) {
        const res = error.request.response;
        if (res.message) {
            app.config.globalProperties.$toast.add({ severity: 'error', summary: app.config.globalProperties.$filters.translate('Chú ý'), detail: res.message, group: "tr", life: 2000 });
        } else
            if (res.error && res.error.Message) {
                app.config.globalProperties.$toast.add({ severity: 'error', summary: app.config.globalProperties.$filters.translate('Chú ý'), detail: res.error.Message, group: "tr", life: 2000 });
            } else {
                app.config.globalProperties.$toast.add({ severity: 'error', summary: app.config.globalProperties.$filters.translate('Chú ý'), detail: error.request.response, group: "tr", life: 2000 });
            }
    }
    return Promise.reject(error);
});